__turbopack_context__.v({
  "className": "caveat_4da562e8-module__vkgOSa__className",
});
